import React, { useState } from 'react';

import AdminContext from '../../../contexts/AdminContext';

import PageTitleNew from '../../ui/PageTitleNew';
import Table from './Table';
import ModalForm from './Form/Modal';

export default function Index() {
  return (
    <AdminContext>
      <div className="wrapper_assestment invite_wrapper">
        <PageTitleNew title="Admins" />

        <div className="ibox-content mt20">
          <Table />
        </div>
      </div>
      <ModalForm />
    </AdminContext>
  );
}
